import React from 'react';
import { X } from 'lucide-react';

export default function VideoModal({ open, onClose, videoUrl, title, isLocal = true }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in-up" onClick={onClose}>
      <button onClick={onClose} aria-label="Close" className="absolute top-4 right-4 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors">
        <X className="h-5 w-5" />
      </button>
      <div className="w-full max-w-5xl aspect-video bg-black rounded-xl overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
        {isLocal ? (
          <video src={videoUrl} controls autoPlay className="w-full h-full" />
        ) : (
          <iframe src={videoUrl} title={title || 'video'} className="w-full h-full" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
        )}
      </div>
      {title && <p className="absolute bottom-6 left-0 right-0 text-center text-white/80 font-serif-display text-lg italic">{title}</p>}
    </div>
  );
}
